import { render, staticRenderFns } from "./SearchBoxIconItem.vue?vue&type=template&id=871e582a&scoped=true&lang=html"
import script from "./SearchBoxIconItem.vue?vue&type=script&lang=js"
export * from "./SearchBoxIconItem.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxIconItem.vue?vue&type=style&index=0&id=871e582a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e582a",
  null
  
)

export default component.exports